import { create } from 'zustand';
import {
  SensorStatus,
  SensorUseCase,
  SensorBillableStatus,
  SensorModel,
  PurchaseOrder,
  SensorsListItem,
  InstallationHistory,
  CommentHistory,
  UploadResponse,
  UploadResponseCounters,
} from '../definitions/sensor';

interface SensorsPage {
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

interface SensorStore {
  sensorsList: SensorsListItem[];
  updateSensorsList: (sensorList: SensorsListItem[]) => void;

  sensorsPage: SensorsPage;
  updateSensorsPage: (sensorsPage: SensorsPage) => void;

  sensorStatuses: SensorStatus[] | [];
  updateSensorStatuses: (sensorStatuses: SensorStatus[]) => void;

  installationHistory: InstallationHistory[];
  updateInstallationHistory: (installationHistory: InstallationHistory[]) => void;

  commentHistory: CommentHistory[];
  updateCommentHistory: (commentHistory: CommentHistory[]) => void;

  sensorUseCases: SensorUseCase[] | [];
  updateSensorUseCases: (sensorUseCases: SensorUseCase[]) => void;

  sensorBillableStatuses: SensorBillableStatus[] | [];
  updateSensorBillableStatuses: (sensorBillableStatuses: SensorBillableStatus[]) => void;

  sensorModels: SensorModel[] | [];
  updateSensorModels: (sensorModels: SensorModel[]) => void;

  sensorPurchaseOrders: PurchaseOrder[] | [];
  updatePurchaseOrders: (sensorPurchaseOrders: PurchaseOrder[]) => void;

  editSensorData: SensorsListItem | null;
  updateEditSensorData: (editSensorData: SensorsListItem | null) => void;

  uploadResponse: UploadResponse[];
  updateUploadResponse: (uploadResponse: UploadResponse[]) => void;

  uploadResponseCounters: UploadResponseCounters;
  updateUploadResponseCounters: (uploadResponse: UploadResponseCounters) => void;

  loading: boolean;
  updateLoading: (loading: boolean) => void;
}

const useSensorStore = create<SensorStore>()((set) => ({
  sensorsList: [],
  updateSensorsList: (sensorsList) => set({ sensorsList }),

  sensorsPage: { totalCount: 0, page: 1, pageSize: 0, totalPages: 0 },
  updateSensorsPage: (sensorsPage) => set({ sensorsPage }),

  installationHistory: [],
  updateInstallationHistory: (installationHistory) => set({ installationHistory }),

  commentHistory: [],
  updateCommentHistory: (commentHistory) => set({ commentHistory }),

  sensorStatuses: [],
  updateSensorStatuses: (sensorStatuses) => set({ sensorStatuses }),

  sensorUseCases: [],
  updateSensorUseCases: (sensorUseCases) => set({ sensorUseCases }),

  sensorBillableStatuses: [],
  updateSensorBillableStatuses: (sensorBillableStatuses) => set({ sensorBillableStatuses }),

  sensorModels: [],
  updateSensorModels: (sensorModels) => set({ sensorModels }),

  sensorPurchaseOrders: [],
  updatePurchaseOrders: (sensorPurchaseOrders) => set({ sensorPurchaseOrders }),

  editSensorData: null,
  updateEditSensorData: (editSensorData) => set({ editSensorData }),

  uploadResponse: [],
  updateUploadResponse: (uploadResponse) => set({ uploadResponse }),

  uploadResponseCounters: {
    processed: 0,
    failed: 0,
  },
  updateUploadResponseCounters: (uploadResponseCounters) => set({ uploadResponseCounters }),

  loading: false,
  updateLoading: (loading) => set({ loading }),
}));

export default useSensorStore;